module.exports = __webpack_public_path__ + "img/10979905_L.66e16e4a.png";